import {AbstractEvent} from "@/modules/base/events";
import {Player} from "@/modules/team/entity";

export class BeforePlayerCareerPlanedEndEvent extends AbstractEvent {
  constructor(
    public player: Player,
  ) {
    super();
  }
}